export const MIN_PARKING_POLYGON_POINTS = 4;
export const MAX_PARKING_POLYGON_POINTS = 100;
const MIN_POLYGON_AREA = 1e-14;

/**
 * Проверяет, что контур состоит из 4–100 разных точек и имеет площадь.
 */
export const isParkingPolygonValid = polygon => {
  if (!Array.isArray(polygon)
    || polygon.length < MIN_PARKING_POLYGON_POINTS
    || polygon.length > MAX_PARKING_POLYGON_POINTS) return false;

  const points = polygon.map(point => ({
    lat: Number(point && point.lat),
    lon: Number(point && point.lon),
  }));
  if (points.some(point => !Number.isFinite(point.lat) || !Number.isFinite(point.lon))) {
    return false;
  }

  const uniquePoints = new Set(points.map(point => `${point.lat}:${point.lon}`));
  if (uniquePoints.size !== points.length) return false;

  const origin = points[0];
  const doubledArea = points.reduce((area, point, index) => {
    const nextPoint = points[(index + 1) % points.length];
    const pointLon = point.lon - origin.lon;
    const pointLat = point.lat - origin.lat;
    const nextLon = nextPoint.lon - origin.lon;
    const nextLat = nextPoint.lat - origin.lat;

    return area + pointLon * nextLat - nextLon * pointLat;
  }, 0);

  return Math.abs(doubledArea) > MIN_POLYGON_AREA;
};
